import type { GetSanAdAccountZeitStatusAction } from '../../actions/getSANAdPartnerZeitStatus';
import type { GetPinterestAdAccountsAction } from './getAdAccounts.action';
import type { GetPinterestAuthenticationUrlAction } from './getAuthenticationUrl.action';

export * from './getAdAccounts.action';
export * from './getAuthenticationUrl.action';

export type PinterestAction =
  | GetPinterestAdAccountsAction
  | GetPinterestAuthenticationUrlAction
  | GetSanAdAccountZeitStatusAction;
